<!-- eslint-disable -->
<template lang="pug">
    .abacus(:class="multiplayerAbacusClassName")
        .abacus__plank-container
            .abacus__plank.abacus__plank--large(
                :style="newStyles.abacusPlankLarge",
                :class="multiplayerAbacusLargePlankClass",
            )
        .abacus__bones-block
            .abacus__digit-block(
                v-for='(digit, index) in digitsArray',
                :key='\'topDigitBoxOnRod\' + index',
                :style="newStyles.abacusDigitBlock",
                :class="multiplayerAbacusDigitBlockClass",
            )
                .abacus__rod(:style="newStyles.abacusRod", :class="multiplayerAbacusRodClass")
                .abacus__bone.abacus__bone--bottom(
                    v-if='digit >= 5',
                    @click='!isStatic && changeNumberOnFive(digit, index)'
                    :style="newStyles.abacusBone"
                    :class="multiplayerAbacusBoneClass"
                )
                .abacus__bone.abacus__bone--top(
                    v-else='',
                    :style="newStyles.abacusBone",
                    @click='!isStatic && changeNumberOnFive(digit, index)',
                    :class="multiplayerAbacusBoneClass",
                )
        .abacus__plank-container
            .abacus__plank(:style="newStyles.abacusPlank", :class="multiplayerAbacusPlankClass")
        .abacus__bones-block
            .abacus__digit-block(
                v-for='(digit, index1) in digitsArray',
                :key='\'downDigitBoxOnRod\' + index1',
                :style="newStyles.abacusDigitBlock",
                :class="multiplayerAbacusDigitBlockClass",
            )
                .abacus__rod(:style="newStyles.abacusRod", :class="multiplayerAbacusRodClass")
                .abacus__bone.abacus__bone-top(
                    :style="newStyles.abacusBone",
                    v-for='(n, index2) in digit%5',
                    @click='!isStatic && subtractNumber(digit, index1, index2)',
                    :class="multiplayerAbacusBoneClass",
                )
                .abacus__bone.abacus__bone--bottom(
                    v-for='(n, index2) in 4 - digit%5',
                    :style="newStyles.abacusBone",
                    @click='!isStatic && appendNumber(digit, index1, index2)'
                    :class="multiplayerAbacusBoneClass",
                )
        .abacus__plank-container
            .abacus__plank.abacus__plank--large(
                :style="newStyles.abacusPlankLarge",
                :class="multiplayerAbacusLargePlankClass"
            )
</template>

<script>
    /*eslint-disable*/
    const GAME_INFO_FLASHCARDS_CLASSNAME = '.opponent__example-abacus';

    export default {
        props: {
            number: {
                type: Number,
                default: null
            },
            gameSettings: {
                type: Object,
                default () {
                    return null
                }
            },
            isStatic: {
                type: Boolean,
                default: false
            },
            maxNumber: {
                type: Number,
                default: undefined
            },
            color: {
                type: String,
                default: 'green'
            },
            isBattleOpponent: {
                type: Boolean,
                default: false,
            },
            abacusNumber: {
                type: String,
                default: '',
            }
        },
        data() {
            return {
                currentIndex: 0,
                numbersArray: [],
                newStyles: {
                    'abacusBone': {},
                    'abacusRod': {},
                    'abacusPlank': {},
                    'abacusPlankLarge': {},
                    'abacusDigitBlock': {}
                },
            }
        },
        mounted () {
            window.addEventListener('resize', this.calculateNewStyles);
            this.calculateNewStyles();
        },
        beforeDestroy () {
            window.removeEventListener('resize', this.calculateNewStyles);
        },
        methods: {
            changeNumberOnFive (number, index) {
                number >= 5 ? number -= 5 : number += 5;
                this.emitNumber(number, index)
            },
            subtractNumber(number, index1, index2) {
                let countOfSpokes = number%5;
                if (countOfSpokes === 1 && index2 === 0) {
                    number -= 1;
                } else if (countOfSpokes === 2) {
                    index2 === 0 ? number -= 2 : number -= 1;
                } else if (countOfSpokes === 3) {
                    if (index2 === 0) number -= 3;
                    if (index2 === 1) number -= 2;
                    if (index2 === 2) number -= 1;
                } else if (countOfSpokes === 4) {
                    if (index2 === 0) number -= 4;
                    if (index2 === 1) number -= 3;
                    if (index2 === 2) number -= 2;
                    if (index2 === 3) number -= 1;
                }
                this.emitNumber(number, index1)
            },
            appendNumber(number, index1, index2) {
                let countOfSpokes = 4 - number%5;
                if (countOfSpokes === 1 && index2 === 0) {
                    number += 1;
                } else if (countOfSpokes === 2) {
                    index2 === 1 ? number += 2 : number += 1;
                } else if (countOfSpokes === 3) {
                    if (index2 === 2) number += 3;
                    if (index2 === 1) number += 2;
                    if (index2 === 0) number += 1;
                } else if (countOfSpokes === 4) {
                    if (index2 === 3) number += 4;
                    if (index2 === 2) number += 3;
                    if (index2 === 1) number += 2;
                    if (index2 === 0) number += 1;
                }
                this.emitNumber(number, index1)
            },
            emitNumber(number, index) {
                this.numbersArray[index] = number;
                let stringOfNumber = '';
                this.numbersArray.forEach(val => {
                    stringOfNumber += val;
                });
                this.$emit('number', Number(stringOfNumber))
            },
            calculateNewStyles () {
                this.newStyles = {
                    'abacusBone': {background: this.colorOfSpoke},
                    'abacusRod': {},
                    'abacusPlank': {},
                    'abacusPlankLarge': {},
                    'abacusDigitBlock': {}
                };
                let selectors = {
                    'abacusBone': `.abacus__bone${this.abacusNumber}`,
                    'abacusRod': `.abacus__rod${this.abacusNumber}`,
                    'abacusPlank': `div.abacus__plank${this.abacusNumber}:not(.abacus__plank--large${this.abacusNumber})`,
                    'abacusPlankLarge': `.abacus__plank--large${this.abacusNumber}`,
                    'abacusDigitBlock': `.abacus__digit-block${this.abacusNumber}`
                };
                Object.keys(selectors).forEach(key => {
                    this.$set(this.newStyles, key, this.getNewElementsSizes(selectors[key], this.newStyles[key]));
                });
            },
            getNewElementsSizes(selector, style) {
                const autoWidthSelectors = [
                    `div.abacus__plank${this.abacusNumber}:not(.abacus__plank--large${this.abacusNumber})`,
                    `.abacus__plank--large${this.abacusNumber}`,
                    `.abacus__digit-block${this.abacusNumber}`
                ];
                const marginSelectors = [`.abacus__digit-block${this.abacusNumber}`];
                const borderRadiusSelectors = [`.abacus__bone${this.abacusNumber}`];
                const elements = Array.from(document.querySelectorAll(selector));
                const elementHeight = (elements.length && elements[0].clientHeight);
                const elementWidth = (elements.length && elements[0].clientWidth);
                const elementMarginRight = (elements.length && parseFloat(getComputedStyle(elements[0]).marginRight));
                const elementBorderRadius = (elements.length && parseFloat(getComputedStyle(elements[0]).borderRadius));
                if (!autoWidthSelectors.includes(selector) && elementWidth) {
                    style.width = elementWidth * this.coefficient + 'px';
                }
                if (marginSelectors.includes(selector) && elementMarginRight) {
                    style['margin-right'] = elementMarginRight * this.coefficient + 'px';
                }
                if (!marginSelectors.includes(selector) && elementHeight) {
                    style.height = elementHeight * this.coefficient + 'px';
                }
                if (borderRadiusSelectors.includes(selector) && elementBorderRadius) {
                    style['border-radius'] = elementBorderRadius * this.coefficient + 'px';
                }
                return style;
            },
        },
        computed: {
            digitsArray () {
                if (!this.isStatic) {
                    let array = this.number.toString().split('').map(Number);
                    while (array.length < this.gameSettings.numberOfSpokes) {
                        array.unshift(0);
                    }
                    while (array.length > this.gameSettings.numberOfSpokes) {
                        array.shift();
                    }
                    this.numbersArray = array;
                    return this.numbersArray
                } else {
                    if (this.maxNumber > 9 && this.number <= 9) {
                        return [0, ...this.number.toString().split('')].map(Number);
                    }
                    return this.number.toString().split('').map(Number);
                }
            },
            coefficient () {
                const initialAbacusHeight = document.querySelector(`.abacus${this.abacusNumber}`).clientHeight;
                let abacusContainerHeight = 0;
                if (!this.isBattleOpponent) {
                    abacusContainerHeight = document.querySelector(`.abacus${this.abacusNumber}`).parentElement.parentElement.clientHeight;
                } else {
                    abacusContainerHeight = document.querySelector(GAME_INFO_FLASHCARDS_CLASSNAME).clientHeight;
                }
                const initialAbacusWidth = document.querySelector(`.abacus${this.abacusNumber}`).clientWidth;
                let abacusContainerWidth = 0;
                if (!this.isBattleOpponent) {
                    abacusContainerWidth = this.isStatic
                        ? document.querySelector(`.abacus${this.abacusNumber}`).parentElement.clientWidth - 10
                        : document.querySelector(`.abacus${this.abacusNumber}`).parentElement.parentElement.clientWidth;
                } else {
                    abacusContainerWidth = document.querySelector(GAME_INFO_FLASHCARDS_CLASSNAME).clientWidth;
                }
                const isSafari = /constructor/i.test(window.HTMLElement)
                        || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari']
                                || (typeof safari !== 'undefined' && safari.pushNotification));
                if (isSafari || initialAbacusHeight > abacusContainerHeight || initialAbacusWidth > abacusContainerWidth || this.isStatic) {
                    return Math.min(
                        abacusContainerWidth * 0.85 / initialAbacusWidth,
                        abacusContainerHeight * 0.85 / initialAbacusHeight
                    );
                }
                return 1;
            },
            colorOfSpoke() {
                return this.gameSettings && this.gameSettings.style && this.gameSettings.style.backgroundColor;
            },
            multiplayerAbacusClassName () {
                if (this.abacusNumber) {
                    return `abacus${this.abacusNumber}`;
                }
                return '';
            },
            multiplayerAbacusBoneClass () {
                if (this.abacusNumber) {
                    return `abacus__bone${this.abacusNumber}`;
                }
                return '';
            },
            multiplayerAbacusRodClass () {
                if (this.abacusNumber) {
                    return `abacus__rod${this.abacusNumber}`;
                }
                return '';
            },
            multiplayerAbacusPlankClass () {
                if (this.abacusNumber) {
                    return `abacus__plank${this.abacusNumber}`;
                }
                return '';
            },
            multiplayerAbacusLargePlankClass () {
                if (this.abacusNumber) {
                    return `abacus__plank--large${this.abacusNumber}`;
                }
                return '';
            },
            multiplayerAbacusDigitBlockClass () {
                if (this.abacusNumber) {
                    return `abacus__digit-block${this.abacusNumber}`;
                }
                return '';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .abacus {
        display: flex;
        flex-direction: column;
    }

    .abacus__plank-container {
        display: flex;
        justify-content: center;
    }

    .abacus__plank {
        width: 100%;
        height: 17px;
        border-radius: 5px;
        $color-burgundy: #8b4220;
        $color-copper: #b87333;
        background: linear-gradient($color-copper, $color-burgundy);
        @include base-shadow;
    }
    .abacus__plank--large {
        height: 34px;
    }
    .abacus__bones-block {
        display: flex;
        flex-direction: row;
    }

    .abacus__digit-block {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 6px;
        @include media($sm) {
            margin-right: 7.38px;
        }
        @include media($md) {
            margin-right: 9.26px;
        }
        @include media($lg) {
            margin-right: 13.83px;
        }
        @include media($xlg) {
            margin-right: 13.79px;
        }
        @include media($xl) {
            margin-right: 18.29px;
        }
        @include media($xxl) {
            margin-right: 26.17px;
        }
    }

    .abacus__digit-block:last-child {
        margin-right: 0 !important;
    }

    .abacus__bone {
        border-radius: 25px;
        box-shadow: inset 0 0 10px 1px rgba(0, 0, 0, 0.2),
        inset -3px 0 3px rgba(255, 255, 255, 0.3);
        background: linear-gradient(to top, #4a7928, #76a554);
        height: 25px;
        width: 35px;
        @media only screen and (min-width: 350px) {
            height: 30px;
            width: 40px;
        }
        @media only screen and (min-width: 450px) {
            height: 35px;
            width: 55px;
        }
        @media only screen and (min-width: 650px) {
            height: 40px;
            width: 70px;
        }
        @media only screen and (min-width: 1300px) {
            height: 50px;
            width: 85px;
        }
    }

    .abacus__bone--top {
        order: 1;
    }

    .abacus__bone--bottom {
        order: 3;
    }

    .abacus__rod {
        height: 40px;
        width: 15px;
        order: 2;
        background: linear-gradient(to right, #8b4220, #b5743a);
        @media only screen and (min-width: 450px) {
            width: 20px;
        }
    }
</style>
